import { apis } from '@/config';
export class MailUpdateResponseInterceptor {
    constructor(interceptors) {
        const [, responseInterceptor] = interceptors;
        responseInterceptor.use({
            namespace: apis.mailApiImpl,
            async resolve(res) {
                const { apiname, namespace } = res.config;
                if (namespace !== apis.mailApiImpl) {
                    return res;
                }
                const { data: mailResponseData } = res;
                if (apiname === 'doListMailBoxEntities') {
                    console.log('[bridge.interceptor]mail.doListMailBoxEntities', mailResponseData);
                }
                else if (apiname === 'doListMailEntitiesFromDb') {
                    console.log('[bridge.interceptor]mail.doListMailEntitiesFromDb', mailResponseData);
                }
                else if (apiname === 'doListMailBox') {
                    console.log('[bridge.interceptor]mail.doListMailBox', mailResponseData);
                }
                return res;
            },
        });
    }
    eject() {
        console.log('eject');
    }
}
